import Vue from 'vue'
import Vuex from 'vuex'
import layout from "./layout"
import auth from "./auth"
import meta from "./meta"
import characteristic from "./characteristic"
import job from "./job";
import jobProfile from "./job-profile";
import jobResult from "./job-result";
import application from "./application";
import communication from "./communication";

Vue.use(Vuex);

const store = new Vuex.Store({
	modules: {
		layout,
		meta,
		auth,
		application,
		characteristic,
		job,
		jobProfile,
		jobResult,
		communication,
	},
});

export default store;
